import React from 'react';
import { inject, observer } from 'mobx-react';
import ItemModify from '../../Form/ItemModify';
import moment from 'moment';

@inject('parameterStore', 'qcRuleStore', 'qcCheckStore', 'stationStore')
@observer
class ParameterQCModify extends React.Component {
  render() {
    const { parameterStore, qcRuleStore, qcCheckStore, stationStore, params } = this.props;
    return (
      <ItemModify
        title={'QC Check'}
        slug={'/qc/check'}
        store={qcCheckStore}
        itemFields={[
          { label: 'Id', key: 'id', type: 'text', readOnly: true, editOnly: true },
          { label: 'Name', key: 'name' },
          { label: 'Description', key: 'description' },
          { label: 'Stations', key: 'stations', type: 'multi-select', options: stationStore.items, isLoading: stationStore.isLoading, fields: { value: 'id', label: 'name', others: ['tags'] }, filterOptions: stationStore.filterStations },
          { label: 'Parameter', key: 'parameter_id', type: 'select', options: parameterStore.items, fields: { value: 'id', label: 'name' }, filterOptions: parameterStore.filterParameters },
          { label: 'Code', key: 'parameter_id', type: 'derived', resolve: id => !id ? '' : parameterStore.findById(id).code },
          { label: 'QC Rules', key: 'qc_rules', type: 'multi-select', options: qcRuleStore.items, isLoading: qcRuleStore.isLoading, fields: { value: 'id', label: 'description' } },
          { label: 'Interval', key: 'interval', type: 'cron-interval' },
          { label: 'Observation ID', key: 'observation_id', defaultValue: 1 },
          { label: 'Timestamp', key: 'timestamp', type: 'datetime', defaultValue: moment().format('YYYY-MM-DDT00:00:00') },
          { label: 'Enabled', key: 'status', type: 'switch', defaultValue: true, editOnly: true },
        ]}
        params={params}
      />
    );
  }
}

export default ParameterQCModify;


// WEBPACK FOOTER //
// ./src/components/QCRule/ParameterQC/ParameterQCModify.js